module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/q2@2x_b3cd2e39d5d078212248ee512c522f8f.png";